import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=0cc8d85d&scoped=true&"
import script from "./UserLogin.vue?vue&type=script&lang=js&"
export * from "./UserLogin.vue?vue&type=script&lang=js&"
import style0 from "./UserLogin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserLogin.vue?vue&type=style&index=1&id=0cc8d85d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc8d85d",
  null
  
)

export default component.exports